import axios from "axios";

// Service for SKU operations used by frontend components.
// Endpoints are assumed; adjust to backend actual routes if different.

const BASE = '/admin/sku'

export default {
  getSkus(params = {}) {
    return axios.get(`${BASE}`, { params });
  },

  getCodeKeys() {
    return axios.get(`${BASE}/codekeys`);
  },

  getSkuByCodeValue(codeValue, codeKey) {
    return axios.get(`${BASE}/${codeValue}`, { params: { codeKey } });
  },

  createSku(payload) {
    return axios.post(`${BASE}`, payload);
  },

  updateSku(codeValue, payload) {
    return axios.put(`${BASE}/${codeValue}`, payload);
  },
};
